
import React from 'react'
import img from "../../assets/Group 1000015002join-us.png"
import { Link } from 'react-router-dom'

const JoinAsATeacher = () => {
  return (
    <section className='w-full pt-24 md:pt-10 bg-[#eeebffb3]'>
        <section className='flex md:flex-col md:w-[90%] justify-between w-[90%] mx-auto'>
            <div className='w-[50%] md:w-full'>
                <img src={img} className='md:w-full pointer-events-none object-contain w-full h-[650px] sm:h-[500px]' alt="medium-shot-smiley-woman-with-laptop " />
            </div>
            <div className='w-[45%] md:w-full my-auto'>
                <h2 className='text-3xl md:text-[32px] font-semibold text-[#312A46] md:mt-0'>
                Do you want to share your knowledge? 
                </h2>
                <h2 className='text-3xl font-semibold text-[#2E2F32] mt-0  md:text-[32px]'>Join us as a teacher</h2>
                <p className='text-[#555454] font-normal text-base my-8 leading-[28px]'>
                Are you passionate about educating and shaping young minds? Do you prioritize quality teaching and want to be part of an exceptional community? If your answer is yes, then we want to hear from you! Join our team at Quest Consult, where we believe that education is the passport to the future. Tomorrow belongs to those who prepare for it today, and we're committed to providing our students with the best possible education to help them succeed. If you're ready to make a difference and inspire the next generation, we can't wait to welcome you aboard."

                </p>
                <Link to="/join-us">
                <button className='mb-0 md:mb-20 bg-[#5146AE] rounded-lg text-white w-[159px] h-[56px] font-medium text-base'>Apply Here</button>
                </Link>
            </div>
        </section>
    </section>
  )
}

export default JoinAsATeacher